import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  RequestMileageConfiguration,
  type RequestMileageConfigurationConstructor,
} from './RequestMileageConfiguration'

export const RequestMileageConfigurationConstructorFactory =
  Factory.Sync.makeFactory<RequestMileageConfigurationConstructor>({
    rate: Factory.each(() =>
      faker.random.number({ min: 1, max: 200, precision: 0.01 })
    ),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    isLocked: Factory.each(() => faker.random.boolean()),
  })

export const RequestMileageConfigurationFactory = EntityFactory(
  RequestMileageConfiguration,
  RequestMileageConfigurationConstructorFactory
)
